import { trackWishlistActions, utagViewArtificialPageView } from 'features/tealium';
import errorMessages from 'features/wishList/errorMessages';

const trackArtificialPageView = utagViewArtificialPageView();

function getFormattedWishlistDate (dateString) {

	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = (1 + date.getMonth()).toString();
	const day = date.getDate().toString();

	return `${month}/${day}/${year}`;

}

function getOpenWishlistTemplate (wishlists, isDefaultView) {

	const template = wishlists
		.map((wishlist, index) => {

			const isCurrentWishlist = index === 0 && !isDefaultView;
			const updatedDate = getFormattedWishlistDate(wishlist.UpdatedDate);
			return `<div class="wlOpenListItem ${isCurrentWishlist ? 'wlOpenListItem--active' : ''}">
					<div>
						<div class="wlOpenListItem__name">
							${wishlist.AssetName}
						</div>
						<div class="wlOpenListItem__details">
							${wishlist.ItemCount} item${wishlist.ItemCount === 1 ? '' : 's'} | ${updatedDate}
						</div>
					</div>
					${
	!isCurrentWishlist
		? `<div>
						<a href="/wish-list/OpenWishList/${encodeURIComponent(
		wishlist.Token
	)}" class="wlItemOpenBtn calloutBtn large alt2 wholeWide">Open</a>
					</div>`
		: ''
}
				</div>`;

		})
		.join('');
	return `
		<div id="wlOpenList" class="wlOpenList">${template}</div>
	`;

}

function getMyWishlists () {

	return fetch('/api/globalwishlists/mywishlist').then((response) => response.json());

}

function initTracking () {

	const openButtonLinks = document.querySelectorAll('.wlItemOpenBtn');

	openButtonLinks.forEach((buttonLink) => {

		buttonLink.addEventListener('click', () => trackWishlistActions({ eventAction: 'Click-Modal-Open-List' }));

	});

}

function setError (errorMessage) {

	const containerElement = document.getElementById('wlOpenListContainer');
	containerElement.innerHTML = `<p>${errorMessage}</p>`;

	$(document.body).lpModalResize({
		height: containerElement.offsetHeight + 60
	});

}

function initOpenView (isDefaultView) {

	const containerElement = document.getElementById('wlOpenListContainer');

	getMyWishlists()
		// eslint-disable-next-line consistent-return
		.then((response) => {

			const wishlists = response.Item?.WishLists ?? null;

			if (!response?.Success || !wishlists) {

				throw Error(errorMessages.Failure);

			}

			containerElement.innerHTML = getOpenWishlistTemplate(wishlists, isDefaultView);
			initTracking();

		})
		.catch((error) => {

			setError(error.message);

		});

}

function showOpenWishListModal ({ isDefaultView = false } = {}) {

	const element = document.createElement('div');
	element.id = 'bdPopup';
	element.innerHTML = `
		<div id="myWishlist" class="popupContent">
			<div class="h1">Open Wish List</div>
			<div id="wlOpenListContainer"></div>
		</div>
	`;

	// Avoid duplicate content due to async issues
	$('#lpModalContent').empty();
	$('body').lpModal({
		onInit: true,
		appendContentToForm: false,
		width: 600,
		height: 475,
		content: $(element),
		lpModalClass: 'lpModal--alt1',
		openEvt: () => initOpenView(isDefaultView),
		closeEvt: () => trackArtificialPageView({ pageName: '' })
	});

	trackWishlistActions({
		eventAction: isDefaultView ? 'Click-DefaultOpenAList' : 'Click-Open-List'
	});

}

export default showOpenWishListModal;
